// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Setup_toggle__30tJJ","title":"Setup_title__3CPqJ","caption":"Setup_caption__1TiKr"};